<bootstrap-popup
	[id]="id"
	[title]="title"
	[windowCloseButton]="true"
	[displaySubject]="displaySubject"
	>

	<form role="form" class="form-horizontal" *ngIf="loaded">
		<div class="panel panel-default panel-horizontal-form-fix">
			<div class="panel-heading"><h3>Le p&eacute;rim&egrave;tre</h3></div>
			<div class="row" style="margin-top: 10px">
				<div class="col-sm-6">
					<div class="form-group choixPerimetreAcces" style="margin-top: 0px" *ngIf="user.role === 'CCE'">
						<antenne-selector
							[id]="'eantenne'"
							[disabled]="mode === 'update'"
							[mandatory]="true"
							[labelClass]="'col-sm-2'"
							[fieldClass]="'col-sm-10'"
							[wildcardOptionLabel]="null"
							[resetCommands]="antenneResetCommands"
							(selectedAntenneChange)="antenne$.next($event)"
							>
						</antenne-selector>
					</div>
					<div class="form-group">
						<parc-filterable-selector
							[id]="'choixparc'"
							[disabled]="mode === 'update'"
							[mandatory]="true"
							[labelClass]="'col-sm-2'"
							[fieldClass]="'col-sm-10'"
							[selectedParcId]="(parc$ | async)?.id"
							[antenneId]="(antenne$ | async)?.id"
							(selectedParcChange)="parc$.next($event)"
							>
						</parc-filterable-selector>
 					</div>
					<div *ngIf="(parc$ | async) as parc" class="form-group" style="margin-bottom: 0px">
						<div class="col-sm-2">&nbsp;</div>
						<div class="col-sm-10 description-parc"> 
							<p *ngIf="parc.type || parc.energie">
								<span *ngIf="parc.type">Type: {{ parc?.type }}</span>
								<span *ngIf="parc.type && parc.energie"> - </span>
								<span *ngIf="parc.energie">Technologie: {{ parc.energie }}</span>
							</p>
							<p *ngIf="responsableParc as responsable">
								<span>R&eacute;f. de parc: {{ responsable.prenom }} {{ responsable.nom }}</span>
								<span *ngIf="responsableParc?.telephone">
									&nbsp;&nbsp;
									<i class="fa fa-phone-square"></i>
									{{ responsable.indicatifTelephone }} {{ responsable.telephone }}
								</span>
								<span *ngIf="responsableParc?.email">
									&nbsp;&nbsp;
									<i class="fa fa-envelope"></i>
									{{ responsable.email }}
								</span>
							</p>
						</div>
					</div>
					<div *ngIf="(antenne$ | async) as antenne" class="form-group" style="margin-bottom: 0px">
						<div class="col-sm-2" *ngIf="antenne.telephoneAstreintes && antenne.telephoneAstreintes.length">&nbsp;</div>
						<div class="col-sm-10 description-antenne" *ngIf="antenne.telephoneAstreintes && antenne.telephoneAstreintes.length"> 
							<p>
								<span>Tel astreinte: {{ antenne.telephoneAstreintes.join(', ') }}</span>
							</p>
						</div>
					</div>
				</div>
				<div class="col-sm-6" style="margin-top: 10px">	
					<div class="form-group">
						 <label for="typeAcces" class="col-sm-3 control-label type-align">Type&nbsp;* :</label>
						 <div class="col-sm-9">
							<label class="radio-inline" *ngFor="let option of typeOptions; let indexOption = index">
								<input type="radio" *ngIf="mode === 'update'" disabled	
									[name]="'typeAcces'"
									[id]="'typeAcces_' + indexOption"
									[value]="option.value" required
									[ngModel]="typeAcces$ | async"
									(ngModelChange)="typeAcces$.next($event)"
								/>
								<input type="radio" *ngIf="mode !== 'update'"
									[name]="'typeAcces'"
									[id]="'typeAcces_' + indexOption"
									[value]="option.value" required
									[ngModel]="typeAcces$ | async"
									(ngModelChange)="typeAcces$.next($event)"
								/>
								{{ option.label }}
							</label>
						 </div>
					</div>
					<div class="form-group" *ngIf="displayedMemosParc?.length">
						<label for="memoParcs" class="col-sm-3 control-label label-memo">M&eacute;mo Parc : </label>
						<div class="col-sm-8">
			    		<ul class="memo-list">
			      			<li class="popover__wrapper" *ngFor="let memo of displayedMemosParc; let i = index">
			        			<div [ngClass]="memo.entity.niveauId == 1 ? 'text-primary' : 'text-danger'">
			          				{{ memo.categorie }} {{ memo.entity.intitule }}
			          				<span *ngIf="memo.entity.dateDebut && !memo.entity.dateFin">
			            				(le {{ memo.entity.dateDebut | displayLocalDate }})
			          				</span>
			          				<span *ngIf="memo.entity.dateDebut && memo.entity.dateFin">
			            				(du {{ memo.entity.dateDebut | displayLocalDate }} au {{ memo.entity.dateFin | displayLocalDate }})
			          				</span>
			        			</div>
			
			        			<div class="popover__content">
			          				<div class="panel panel-default">
			            				<div class="panel-heading" role="document">
			              					<h3>Commentaire</h3>
			            				</div>
			            				<div class="panel-body">
			              					<p>{{ memo.entity.commentaire }}</p>
			            				</div>
			          				</div>
			        			</div>
			      			</li>
			    		</ul>
						</div>
					</div>
				</div>
			</div> 
			<div class="row" style="margin-top: 10px" *ngIf="(parc$ | async) as parc">
				<div class="col-sm-12">
					<div class="form-group">
						<label for="choixOuvrages" class="col-sm-1 control-label">Ouvrage&nbsp;*:</label>
						<div class="col-sm-11 groupChoixOuvrages">
							<ouvrage-by-sous-parc-multi-selector-with-notes
								[id]="'choixOuvrages'"
								[maxNumberOfSelections]="maxOuvrageSelectables$ | async"
								[disabled]="mode === 'update' || !!(modeSolaireLocal$ | async)"
								[fieldClass]="'col-sm-6 selector'"
								[notesClass]="'col-sm-5'"
								[dateRef]="dateTimeDebutJS$ | async"
								[reinitCommands]="reinitOuvragesFieldCommands$"
								(selectedOuvragesChange)="ouvrages$.next($event)"
								>
							</ouvrage-by-sous-parc-multi-selector-with-notes>
						</div>
					</div>
				</div>
				<div class="col-sm-12">
					<div class="form-group" style="margin-bottom: 0px" *ngIf="allowsOuvragesConcernes$ | async">
						<label for="choixOuvragesConcernes" class="col-sm-1 control-label" style="padding-top: 0px">Ouvrage(s)<br/>concern&eacute;(s)&nbsp;:</label>
						<div class="col-sm-11 groupChoixOuvrages">
							<ouvrage-by-sous-parc-multi-selector-with-notes
								[id]="'choixOuvragesConcernes'"
								[disabled]="acces != null && acces.etat > 1 && mode !== 'duplicate'"
								[fieldClass]="'col-sm-6 selector'"
								[notesClass]="'col-sm-5'"
								[dateRef]="dateTimeDebutJS$ | async"
								[reinitCommands]="reinitOuvragesConcernesFieldCommands$"
								(selectedOuvragesChange)="ouvragesConcernes$.next($event)"
							>
							</ouvrage-by-sous-parc-multi-selector-with-notes>
						</div>
					</div>
				</div>
<!-- 				<div class="col-sm-12" *ngIf="(parc$ | async) as parc">
					<div class="form-group" *ngIf="parc.vigilanceIncendie === '1' && (niveauAlertIncendie$ | async) as niveau">
						<label class="col-sm-1 control-label" style="padding-top: 0px">M&eacute;t&eacute;o&nbsp;: </label>
						<div class="col-sm-11 popover__wrapper" style="margin-top: 0px">
							<a href="#">
								<i class="fa fa-2x fa-fire" [style.color]="niveau.codeCouleurAurora"></i>
							</a>
							<div class="popover__content">
								<div class="panel panel-default modal-sm">
									<div class="panel-heading" role="document">
										<h3>D&eacute;tails</h3>
									</div>
									<div class="panel-body">
										<strong>Niveau incendie:</strong><br/>
										<span>{{ parc.niveauIncendie ? niveau.couleurCassini : 'inconnu' }}</span><br/>
										<br/>
										<ng-container *ngIf="parc.regleIncendie">
											<strong>R&egrave;gle applicable incendie:</strong><br/>
											<span>{{ parc.regleIncendie }}</span>
										</ng-container>
										<strong *ngIf="!parc.regleIncendie">Aucune r&egrave;gle incendie connue.</strong>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div> -->
				<div class="col-sm-12">
					<ng-container *ngIf="(indicateurs$ | async) as indicateurs">
						<div class="form-group" *ngIf="indicateurs.length">
							<label class="col-sm-1 control-label" style="padding-top: 0px">M&eacute;t&eacute;o&nbsp;: </label>
							<div class="col-sm-11 indicateurs-list">
								<span class="popover__wrapper" *ngFor="let indicateur of indicateurs">
									<i class="fa-2x {{ indicateur.icon }}" [style.color]="indicateur.couleur"></i>
									<div class="popover__content">
										<div class="panel panel-default modal-sm">
											<div class="panel-heading" role="document">
												<h3>{{ indicateur.nom }}</h3>
											</div>
											<div class="panel-body">
												<strong>Niveau&nbsp;:</strong><br/>
												<span>{{ indicateur.niveau }}</span><br/>
												<br/>
												<ng-container *ngIf="indicateur.regle">
													<strong>R&egrave;gle applicable&nbsp;:</strong><br/>
													<span class="regle">{{ indicateur.regle }}</span>
												</ng-container>
												<strong *ngIf="!indicateur.regle">Aucune r&egrave;gle connue.</strong><br/>
												<br/>
												<ng-container *ngIf="indicateur.dateModification">
												<strong>Date de dernière modification&nbsp;:</strong><br/>
												<span class="regle">{{ indicateur.dateModification | localDateTimeToDate: true | date : 'dd/MM/yyyy à HH:mm' }}</span>
												</ng-container>
											</div>
										</div>
									</div>
								</span>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
		<div class="panel panel-default">
			<div class="panel-heading"><h3>Les intervenants</h3></div>
			<div class="panel-body tablecontainer">
				<table class="table table-striped acces-intervenants">
					<thead>
						<tr>
							<th></th>
							<th>R&ocirc;le</th>
							<th>Entreprise *</th>
							<th>Intervenant</th>
							<th><i class="fa fa-phone-square"></i> &nbsp; <i class="fa fa-envelope"></i></th>
							<th>Habilitations</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let input of (intervenantsInputs$ | async); let index = index">
							<td class="text-center">
								<span class="clickable" *ngIf="index != 0">
									<i class="fa fa-trash fa-2x text-danger" (click)="removeIntervenantInput(index)"></i>
								</span>
							</td>
							<td>
								<select
									[name]="'role_' + index" [id]="'role_' + index"
									class="form-control"
									style="width: 20em"
									[(ngModel)]="input.role"
									(change)="roleHasChanged(index)"
									>
									<option *ngFor="let option of intervenantRoles" [ngValue]="option.id">{{ option.label }}</option>
								</select>
							</td>
							
							<td>
								<filterable-select
									[id]="'entreprise_' + index"
									[inputClass]="'form-control'"
									[list]="entreprisesSelectionables"
									[labelGetter]="getEntrepriseNom"
									[selectedItem] = "input.entreprise"
									(selectedItemChange) = "onEntrepriseChange(index, $event)"
									>
								</filterable-select>
							</td>
							<td>
								<filterable-select *ngIf="entreprisesById != null && input.entreprise"
									[id]="'intervenant_' + index + '_entreprise_' + input.entreprise.id"
									[inputClass]="'form-control'"
									[list]="intervenantsSelectionablesByEntreprise[input.entreprise.id]"
									[labelGetter]="getIntervenantNom" 
									[selectedItem] = "input.intervenant"
									(selectedItemChange) = "onIntervenantChange(index, $event)"
									>
								</filterable-select>
								<filterable-select *ngIf="entreprisesById != null && !input.entreprise"
									[id]="'intervenant_' + index + '_global'"
									[inputClass]="'form-control'"
									[list]="intervenantsSelectionables"
									[labelGetter]="getIntervenantNom" 
									[selectedItem] = "input.intervenant"
									(selectedItemChange) = "onIntervenantChange(index, $event)"
									>
								</filterable-select>
							</td >
							<td class="infosChargeAcces">
								<div *ngIf="input.intervenant && !input.modificationContacts">
									<span>
										{{ input.indicatifTelephone ? input.indicatifTelephone.dialCode : '' }}&nbsp;{{ input.telephone }}
										<i class="fa-solid fa-pen-to-square" title='Modifier les coordonnées' (click)="input.modificationContacts = true"></i>
									</span>
									<span>{{ input.email }}</span>
								</div>
								<div *ngIf="input.intervenant && input.modificationContacts"
									class="intervenant-inline"
									(keydown.enter)="onInputModificationContact(input)"
									(keydown.escape)="onCancelModificationContact(input)"
									>
									<div class="col-sm-5">
										<filterable-select
											[inputClass]="'form-control'" 
											[list]="indicatifTelephoneOptions"
											[labelGetter]="getIndicatifLabel" 
											[selectedItem]="input.indicatifTelephone"
											(selectedItemChange)="input.indicatifTelephone = $event"
											>
										</filterable-select>
									</div>
									<div class="col-sm-7">
										<input class="form-control" type="text" id="phone" name="phone" [(ngModel)]="input.telephone" maxlength="15" oninput="this.value = this.value.replace(/\D/g, '')" />
							 		</div>
								</div>
								<div *ngIf="input.intervenant && input.modificationContacts"
									class="intervenant-inline col-sm-12 email-editor" 
									(keydown.enter)="onInputModificationContact(input)"
									(keydown.escape)="onCancelModificationContact(input)"
									>
									<div class="col-sm-11">
										<input class="form-control" type="text" id="email" name="email" [(ngModel)]="input.email" maxlength="255" />
									</div>
									<div class="col-sm-1">
										<i class="fa-regular fa-floppy-disk fa-2x" title='Enregistrer vos modifications' (click)="onInputModificationContact(input)"></i>
									</div>
								</div>
							</td>
							<td class="habilitations-inter">
								<intervenant-status *ngIf="input.intervenant" [idIntervenant]="input.intervenant ? input.intervenant.id : 0" [ouvrages]="(ouvrages$ | async)" 
										[spacing]="'10px'" [idParc]="(parc$ | async)?.id" [idIntervenant]="input.intervenant.id" [shouldBlink]="input.shouldBlink" [pdpIconsToShow]="input.displayablePdpTypes" >
								</intervenant-status>
							</td>
						</tr>
						<tr>
							<td></td>
							<td colspan="5">
								<button type="button" class="btn btn-primary btn-sm" (click)="addIntervenantInput()">
									Ajouter
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
						
		<div class="panel panel-default">
			<div class="panel-heading"><h3>L'acc&egrave;s</h3></div>
			<div class="panel-body">
				<div class="form-group">
					<label for="numeroTransfert" class="col-sm-3 control-label">Num&eacute;ro de transfert&nbsp;:</label>
					<div class="col-sm-4">
						<input type="text"
							id="numeroTransfert"
							name="numeroTransfert"
							class="form-control"
							readonly="readonly"
							[ngModel]="numero$ | async"
						/>
					</div>
				</div>
				<div class="form-group">
					<label for="heureDebut" class="col-sm-3 col-xs-3 control-label">Heure de d&eacute;but&nbsp;*:</label>
					<div class="col-sm-1 col-xs-9">
						<time-input
							[id]="'heureDebut'"
							[disabled]="(mode === 'update' && acces != null && acces.etat > 1)"
							[stepMinute]="1"
							[localTime]="heureDebut$ | async"
							(localTimeChange)="heureDebut$.next($event)"
							>
						</time-input>
					</div>
					<label for="dateDebut" class="col-sm-1 col-xs-3 control-label">le&nbsp;*:</label>
					<div class="col-sm-2 col-xs-9">
						<date-input 
							[id]="'dateDebut'"
							[disabled]="acces != null && acces.etat > 1"
							[localDate]="dateDebut$ | async"
							(localDateChange)="dateDebut$.next($event)"
						>
						</date-input>
					</div>
					<button
						*ngIf="acces != null && acces.etat <= 1"
						type="button"
						class="btn btn-primary btn-xs"
						style="margin-top: 5px"
						(click)="resetDateCommands.next()"
						>
						Date et heure actuelle
					</button>
				</div>
				<div class="form-group">
					<label for="commentaire" class="col-sm-3 control-label">Commentaire&nbsp;:</label>
					<div class="col-sm-9">
						<textarea type="text"
							id="commentaire" name="commentaire"
							class="form-control"
							maxlength="512"
							[(ngModel)]="commentaire"
							>
						</textarea>
					</div>
				</div>
				<div class="form-group" *ngIf="mode == 'creation'">
					<label for="lierIntervention" class="col-sm-3 control-label">Lier &agrave; une op&eacute;ration&nbsp;*?</label>
					<div class="col-sm-9">
						<label class="radio-inline" *ngFor="let option of ouiNonOptions; let indexOption = index">
							<input type="radio"
								[name]="'lierIntervention'"
								[id]="'lierIntervention_' + indexOption"
								[value]="option.value"
								[disabled]="(accesCegex$ | async) === true"
								required
								[(ngModel)]="lierIntervention"
							/>
							{{ option.label }}
						</label>
					 </div>
				</div>
				<div class="form-group">
					<label for="accesCegex" class="col-sm-3 control-label">Acc&egrave;s CEGEX&nbsp;*?</label>
					<div class="col-sm-9">
						<label class="radio-inline" *ngFor="let option of ouiNonOptions; let indexOption = index">
							<input type="radio"
								[name]="'accesCegex'"
								[id]="'accesCegex_' + indexOption"
								[value]="option.value"
								*ngIf="(mode === 'update' && acces != null && acces.etat > 1)" disabled
								required
								[ngModel]="accesCegex$ | async"
								(ngModelChange)="accesCegex$.next($event)"
							/>
							<input type="radio"
								[name]="'accesCegex'"
								[id]="'accesCegex_' + indexOption"
								[value]="option.value"
								*ngIf="!(mode === 'update' && acces != null && acces.etat > 1)" 
								required
								[ngModel]="accesCegex$ | async"
								(ngModelChange)="accesCegex$.next($event)"
							/>
							{{ option.label }}
						</label>
					</div>
				</div>
				<div class="form-group">
					<label for="astreinte" class="col-sm-3 control-label">Astreinte&nbsp;?</label>
					<div class="col-sm-9">
						<label class="radio-inline" *ngFor="let option of ouiNonOptions; let indexOption = index">
							<input type="radio"
								[name]="'astreinte'"
								[id]="'astreinte_' + indexOption"
								[value]="option.value"
								disabled
								required
								[ngModel]="astreinte$ | async"
							/>
							{{ option.label }}
						</label>
					 </div>
				</div>
			</div>
		</div>
		<div class="form-group">
			<div class="col-sm-12 text-center actions">
				<button 
					type="button"
					class="btn btn-default"
					(click)="close()"
					>
					Annuler
				</button>&nbsp;
				<ng-container *ngIf="mode === 'creation'">
					<button
						type="button"
						class="btn btn-primary"
						[disabled]="waitingForServer"
						(click)="createNewPlannedAcces(false)"
						>
						Planifier
					</button>
					<button type="button"
						*ngIf="!(userCanGrantAcces$ | async) && atLeastOneOuvrageSelected() && allIntervenantsFilled()"
						class="btn btn-success"
						[disabled]="waitingForServer"
						(click)="createNewPlannedAcces(true)"
						>
						Demander une validation
					</button>
					<button
						*ngIf="(userCanGrantAcces$ | async) && allIntervenantsFilled()"
						type="button"
						class="btn btn-success"
						[disabled]="waitingForServer"
						(click)="createNewGrantedAcces()"
						>
						Autoriser
					</button>
				</ng-container>
				<ng-container *ngIf="mode === 'update'">
					<button
						type="button"
						class="btn btn-primary"
						[disabled]="waitingForServer"
						(click)="updateAcces()"
						>
						Enregistrer
					</button>&nbsp;
					<button
						*ngIf="(userCanGrantAcces$ | async) && acces && acces.etat <= 1 && allIntervenantsFilled()"
						type="button"
						class="btn btn-success"
						[disabled]="waitingForServer"
						(click)="updateAndGrantAcces()"
						>
						Enregistrer et Autoriser
					</button>&nbsp;
				</ng-container>
				<ng-container *ngIf="mode !== 'duplicate' && (!acces || acces.etat <= 1) && (userCanGrantAcces$ | async) && allIntervenantsFilled()">
					<select
						name="controleSecurite" id="controleSecurite"
						class="form-control"
						style="width: 18em; display: inline; padding-top: 3px;"
						[(ngModel)]="controleSecurite"
						>
						<option [ngValue]="null">&nbsp;</option>
						<option *ngFor="let option of (controlesSecurite$ | async)" [ngValue]="option.id">{{ option.label }}</option>
					</select>
					<button type="button"
						class="btn btn-danger"
						[disabled]="waitingForServer"
						(click)="mode === 'update' ? updateAndDenyAcces() : createNewDeniedAcces()" >
						Refuser
					</button>
					<select
						name="motifRefus" id="motifRefus"
						class="form-control"
						style="width: 18em; display: inline; padding-top: 3px;"
						[(ngModel)]="motifRefus"
						>
						<option [ngValue]="null">&nbsp;</option>
						<option *ngFor="let option of (motifsRefus$ | async)" [ngValue]="option.id">{{ option.libelle }}</option>
					</select>
				</ng-container>
			</div>
		</div>
	</form>
</bootstrap-popup>

<coactivite-solaire-checker
	[id]="'coactiviteSolCheckerDialogOfModal'"
	[checkCommands]="checkCoactiviteSolaireCommands"
	>
</coactivite-solaire-checker>

<coactivite-eolien-checker
	[id]="'coactiviteEolCheckerDialogOfModal'"
	[checkCommands]="checkCoactiviteEolienCommands"
	>
</coactivite-eolien-checker>